import styled from 'styled-components'

export const AppContainer = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.palette.background.muted};
`

export const MainContainer = styled.div`
  display: flex;
  max-width: 1400px;
  margin: 0 auto;
  gap: ${({ theme }) => theme.spacing[60]};
`

export const MainContent = styled.main`
  flex: 1;
  padding: ${({ theme }) => theme.spacing[60]};
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.border.radius.lg};
  box-shadow: ${({ theme }) => theme.elevation.bottom.sm};
  margin: ${({ theme }) => theme.spacing[60]} 0;
`

export const LoadingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.background.muted};
`

export const LoadingSpinner = styled.div`
  text-align: center;
`

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid ${({ theme }) => theme.palette.surface.subtle};
  border-top: 4px solid ${({ theme }) => theme.palette.primary.default};
  border-radius: 50%;
  margin: 0 auto 1rem;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

export const LoadingText = styled.p`
  color: ${({ theme }) => theme.palette.text.support};
  font-weight: ${({ theme }) => theme.typography.weight.medium};
  font-family: ${({ theme }) => theme.typography.body.family};
  font-size: ${({ theme }) => theme.typography.body.size.md};
`